import axios from './index';

export default {
    find,
    patientHasDerived
}

async function find({ term }) {
    const result = await axios.get('api/v1/medicalPractitioners', { params: { term } });
    return result.data;
}

async function patientHasDerived({ medicalRecordNumber }) {
    const result = await axios.get('api/v1/medicalPractitioners/patient/hasDerived', { params: { medicalRecordNumber } })

    return result.data.isDerived;
}
